var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriverScore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 127,
    viewBox: "0 0 139 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8496 1.83623C67.0064 -0.612078 72.9907 -0.612075 78.1475 1.83623L128.147 25.575C134.775 28.7215 138.999 35.4023 138.999 42.7387V84.2337C138.999 91.5701 134.775 98.251 128.147 101.397L78.1475 125.136C72.9907 127.585 67.0064 127.585 61.8496 125.136L11.8496 101.397C5.22224 98.251 0.998535 91.5701 0.998535 84.2337V42.7387C0.998535 35.4023 5.22224 28.7215 11.8496 25.575L61.8496 1.83623Z",
    fill: "#18303E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverScore);
export default __webpack_public_path__ + "static/media/driver_score.060eff35302706ef4e520368495b94c8.svg";
export { ForwardRef as ReactComponent };